import { CheckCircle2 } from "lucide-react";
import { PAYMENT_METHODS } from "@/shared/constants/paymentMethods";

export default function PaymentMethodSelector({
  selectedId,
  onSelect,
  error,
  fieldRef,
}) {
  return (
    <div className="space-y-2">
      <div
        ref={fieldRef}
        className="grid grid-cols-1 sm:grid-cols-2 gap-3"
      >
        {PAYMENT_METHODS.map((method) => (
          <button
            key={method.id}
            type="button"
            onClick={() => onSelect(method.id)}
            className={`relative flex items-center gap-3 p-4 rounded-xl border-2 transition-all ${
              selectedId === method.id
                ? method.bgSelected
                : `border-slate-200 ${method.bgHover}`
            }`}
          >
            <img
              src={method.logo}
              alt={method.id}
              className="w-10 h-10 object-contain rounded"
            />
            <div className="text-left">
              <p className="font-semibold text-slate-900">{method.name}</p>
              <p className="text-xs text-slate-500">Mobile Wallet</p>
            </div>
            {selectedId === method.id && (
              <CheckCircle2 className="absolute top-2 right-2 h-5 w-5 opacity-70 text-slate-900" />
            )}
          </button>
        ))}
      </div>
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
}
